import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationStats = ({ total, unread, read }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {/* Total Notifications */}
      <div className="bg-card border border-border rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Total Notifications</p>
            <p className="text-2xl font-bold text-foreground">{total}</p>
          </div>
          <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center">
            <Icon name="Bell" size={24} className="text-blue-600" />
          </div>
        </div>
      </div>

      {/* Unread Notifications */}
      <div className="bg-card border border-border rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Unread</p>
            <p className="text-2xl font-bold text-orange-600">{unread}</p>
          </div>
          <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center">
            <Icon name="AlertCircle" size={24} className="text-orange-600" />
          </div>
        </div>
      </div>

      {/* Read Notifications */}
      <div className="bg-card border border-border rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Read</p>
            <p className="text-2xl font-bold text-green-600">{read}</p>
          </div>
          <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center">
            <Icon name="CheckCircle" size={24} className="text-green-600" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationStats;